import { render, staticRenderFns } from "./AddTextForm.vue?vue&type=template&id=293ff6d0&"
import script from "./AddTextForm.vue?vue&type=script&lang=js&"
export * from "./AddTextForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports